// import React from 'react'

// const PostJob = () => {
//   return (
//     <div>PostJob</div>
//   )
// }

// export default PostJob


import React, { useEffect, useRef, useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import CustomFromAndToDate from '../../../../Components/CustomFromAndToDate/CustomFromAndToDate';
import CustomRadioButton from '../../../../Components/CustomRadioButton/CustomRadioButton';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import actions from '../../../../ReduxStore/actions';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';
import CustomAddMultipleInputs from '../../../../Components/CustomInputLogin/CustomAddMultipleInputs';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const PostJob = ({ handleAddFormGoBackButton, editById }) => {
    const [uploadedFile, setUploadedFile] = useState(null);

    const jobType = [
        { value: "permanent", label: "Permanent" },
        { value: "contract", label: "Contract" },
        { value: "freelance", label: "Freelance" },
    ];

    const fullPartTimeData = [
        { value: "Full Time", label: "Full-time" },
        { value: "Part Time", label: "Part-time" },
    ];
    const experienceTypeData = [
        { value: "fresher", label: "Fresher" },
        { value: "experienced", label: "Experience" },
    ];


    // const handleSubmit = (values, { resetForm }) => {
    //     console.log("Form Values of contact form:", values);
    //     // const data1 = { data: values, method: "post", apiName: "postContactUsForm" };
    //     resetForm();
    //     setUploadedFile(null)

    // };





    const formikRef = useRef();
    const [inputValue, setInputValue] = useState("");
    const [localValues, setLocalValues] = useState([]);
    console.log(localValues, "localValues")



    console.log(editById, "editbyidddddd")
    const dispatch = useDispatch()

    const { EventPost } = useSelector(
        (state) => state?.EventPost
    );
    const [loading, setLoading] = useState(false);


    console.log(EventPost, "EventPostEventPost")
    // const countries = [
    //     { value: "India", label: "India" },
    //     { value: "USA", label: "USA" },
    //     { value: "UK", label: "UK" },
    //     { value: "Australia", label: "Australia" },
    // ];

    const campusName = [
        { value: "Campus", label: "Campus" },

    ];

    // useEffect(() => {


    //     if (editById) {

    //         const fetchData = async () => {
    //             const data1 = {
    //                 data: {},
    //                 method: "put",
    //                 apiName: `event/${editById}`,
    //             };
    //             const response = await dispatch(actions.EVENTGETBYID(data1));

    //             console.log(response, "responseresponse")
    //             const { setFieldValue } = formikRef.current;


    //             if (response?.payload?.message === "Event fetched successfully.") {
    //                 //     console.log("hiiii")



    //                 setFieldValue("CampusName", response?.payload?.data?.campusname)
    //                 setFieldValue("EventTitle", response?.payload?.data?.eventtitle)
    //                 setFieldValue("details", response?.payload?.data?.eventdetails)
    //                 setFieldValue("fromDate", response?.payload?.data?.event_startdate)
    //                 setFieldValue("toDate", response?.payload?.data?.event_enddate)



    //             //     const data = response?.payload?.data;

    //             //     const uploadedFiles = [];

    //             //     for (let i = 1; i <= 7; i++) {
    //             //         const imageKey = `image${i}`;
    //             //         const imgUrlKey = `img_url${i}`;

    //             //         if (data?.[imageKey] && data?.[imgUrlKey]) {
    //             //             uploadedFiles.push({
    //             //                 id: i,
    //             //                 fileUrl: data[imgUrlKey],
    //             //                 type: "img",
    //             //                 progress: 100,
    //             //             });
    //             //         }
    //             //     }

    //             //     setUploadedFile(uploadedFiles);


    //             }
    //         };
    //         fetchData();
    //     }

    // }, []);


    const sessionUserId = sessionStorage.getItem("userId")

    const handleSubmit = async (values, { resetForm }) => {
        console.log("Form Values of contact form:", values);
        setLoading(true)
        // const formData = new FormData();
        // formData.append("event_startdate", values?.fromDate);
        // formData.append("event_enddate", values?.toDate);
        // formData.append("campusname", values?.CampusName);
        // formData.append("eventtitle", values?.EventTitle);
        // formData.append("eventdetails", values?.details);


        const data1 = {
            data: {
                user_id: sessionUserId,
                company_name: values?.companyName,
                skills: values?.skills,
                job_title: values?.jobTitle,
                full_or_part_time: values?.full_partTime,
                job_type: values?.jobType,
                posted_date: values?.fromDate,
                location: values?.location,
                last_date: values?.toDate,
                description: values?.description,
                contact_person: values?.contactPerson,
                status: values?.experienceType,
                experience: values?.experience,
                mobile_no: values.mobile_number.toString(),
                url: values?.url,
                ctc_per_annum: values?.ctc_perannum,
                special_offer: values?.specialOffer,
                educational_qualification: values?.educationalQualification,



            },
            method: "post",
            apiName: `createJobPost`,
            // isFormData: true,
        };

        const responseData = await dispatch(actions.ADDPOSTJOB(data1));
        console.log(responseData, "responseDataresponseData")
        if (responseData?.payload?.message === "Job posted successfully") {
            setLoading(false)
            // toast.success(`Event ${editById ? "updated" : "created"} successfully`);

            handleAddFormGoBackButton();
            setTimeout(() => {
                // handleAddFormGoBackButton();
                toast.success(`Job posted successfully`);



            }, 1500);

            resetForm();
            setUploadedFile([]); // Clear uploaded files
            // setTimeout(() => {
            // }, 2500);


        } else {
            setLoading(false)

            toast.error(responseData?.payload?.message)

        }
    };
    const validationSchema = Yup.object().shape({
        companyName: Yup.string().required('Company Name is required'),
        jobTitle: Yup.string().required('Job Title is required'),
        jobType: Yup.string().required('Job Type is required'),
        location: Yup.string().required('Location is required'),
        // skills: Yup.string().required('Skills are required'),
        full_partTime: Yup.string().required('Full/Part Time is required'),
        contactPerson: Yup.string().required('Contact Person is required'),
        mobile_number: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Mobile number is required'),
        url: Yup.string().url('Invalid URL'),
        experienceType: Yup.string().required('Please select experience type'),
        experience: Yup.string().when('experienceType', {
            is: 'Experience',
            then: Yup.string().required('Experience is required'),
        }),
        ctc_perannum: Yup.number().typeError('Must be a number'),
        specialOffer: Yup.string(),
        educationalQualification: Yup.string().required('Educational Qualification is required'),
        description: Yup.string().required('Description is required'),
    });




    return (
        <Box>
            <Box data-aos="zoom-in" data-aos-duration="1000"
                sx={{
                    position: 'relative',
                }}
            >
                {loading && <FullPageLoader />}

                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                    <Typography variant="h6" gutterBottom>Post Job</Typography>
                                    <Divider />
                                    <Box>
                                        <Formik
                                            initialValues={{
                                                companyName: "",
                                                jobTitle: "",
                                                jobType: "",
                                                location: "",
                                                skills: [],
                                                full_partTime: "",
                                                contactPerson: "",
                                                mobile_number: "",
                                                url: "",
                                                experienceType: "fresher",
                                                fromDate: "",
                                                toDate: "",
                                                experience: "",
                                                ctc_perannum: "",
                                                specialOffer: "",
                                                educationalQualification: "",
                                                description: "",
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={handleSubmit}
                                        >
                                            {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
                                                <Form>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2,
                                                            mt: 2
                                                        }}
                                                    >


                                                        <Grid container spacing={2}>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Company Name"
                                                                    name="companyName"
                                                                    custPlaceholder="Enter Company Name"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Job Title"
                                                                    name="jobTitle"
                                                                    custPlaceholder="Enter Job Title"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                                <CustomDropdownMui
                                                                    label="Job Type"
                                                                    name="jobType"
                                                                    options={jobType}
                                                                    custPlaceholder="Select Job Type"
                                                                // image={country_icon}
                                                                // important={true}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Location"
                                                                    name="location"
                                                                    custPlaceholder="Enter Location"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                {/* <CustomInputLogin
                                                                    label="Skills"
                                                                    name="skills"
                                                                    custPlaceholder="Enter Skills"
                                                                    inputType="input"
                                                                /> */}
                                                                <CustomAddMultipleInputs
                                                                    label="Skills"
                                                                    name="skills"
                                                                    inputType="text"
                                                                    custPlaceholder="Enter skills"
                                                                    setFieldValue={setFieldValue}
                                                                    values={values.skills}
                                                                    inputValue={inputValue} // Pass inputValue
                                                                    setInputValue={setInputValue} //
                                                                    localValues={localValues}
                                                                    setLocalValues={setLocalValues}

                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                {/* <CustomInputLogin
                                                                    label="Full/Part Time"
                                                                    name="full_partTime"
                                                                    custPlaceholder="Enter Skills"
                                                                    inputType="input"
                                                                /> */}

                                                                <CustomDropdownMui
                                                                    label="Full/Part Time"
                                                                    name="full_partTime"
                                                                    options={fullPartTimeData}
                                                                    custPlaceholder="Select Type"
                                                                // image={country_icon}
                                                                // important={true}
                                                                />
                                                            </Grid>

                                                            {/* <Grid size={{md:4}}> */}
                                                            <CustomFromAndToDate label1="Posted Date" label2="Last Date" />
                                                            {/* </Grid> */}
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Contact Person"
                                                                    name="contactPerson"
                                                                    custPlaceholder="Enter Contact Person"
                                                                    inputType="input"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Mobile No"
                                                                    name="mobile_number"
                                                                    custPlaceholder="Enter Mobile Number"
                                                                    inputType="Number"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="URL"
                                                                    name="url"
                                                                    custPlaceholder="Enter URL"
                                                                    inputType="input"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomRadioButton
                                                                    name="experienceType"
                                                                    value="fresher"
                                                                    // onChange={(val) => console.log("Selected:", val)}
                                                                    options={experienceTypeData}
                                                                />

                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Experience (in Year & Months)"
                                                                    name="experience"
                                                                    custPlaceholder="Enter Experience"
                                                                    inputType="input"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="CTC Per Annum (in lakhs)"
                                                                    name="ctc_perannum"
                                                                    custPlaceholder="Enter CTC Per Annum"
                                                                    inputType="number"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Special Offer"
                                                                    name="specialOffer"
                                                                    custPlaceholder="Enter Special Offer"
                                                                    inputType="input"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Educational Qualification"
                                                                    name="educationalQualification"
                                                                    custPlaceholder="Enter Experience"
                                                                    inputType="input"
                                                                />
                                                            </Grid>


                                                            <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                                                                <CustomInputLogin
                                                                    label="Description"
                                                                    name="description"
                                                                    custPlaceholder="Description"
                                                                    inputType="textarea"
                                                                />
                                                            </Grid>


                                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                                <Button
                                                                    onClick={() => {
                                                                        // resetForm()
                                                                        handleAddFormGoBackButton()
                                                                    }}
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "black",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },
                                                                        marginRight: "5px",
                                                                        boxShadow: 1,
                                                                        border: "1px solid #ced4da",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "white 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "white",
                                                                        },
                                                                    }}
                                                                >
                                                                    Go back
                                                                </Button>
                                                                <Button
                                                                    type="submit"
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "white",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },

                                                                        boxShadow: "none",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "var(--main-color)",
                                                                        },
                                                                    }}
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </Grid>

                                                        </Grid>




                                                    </Box>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Box>
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
            </Box>

            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box>
    )
}

export default PostJob